// Whether this session may READ rate cards and recipes (financial_products,
// product_recipes). The role in THIS business decides, plus platform and
// support views — see canReadRateCards (src/lib/roles.ts), which mirrors the
// read policies of mig 20261142500000. Below it the read succeeds with no rows,
// so screens must not read at all.
import { useCurrentUser } from '@/lib/useCurrentUser'
import { usePlatformView, useSupportView } from '@/lib/platformView'
import { canReadRateCards } from '@/lib/roles'

export function useCanReadRateCards(): boolean {
  const { data: me } = useCurrentUser()
  const inPlatformView = usePlatformView()
  const inSupportView = useSupportView()
  return canReadRateCards(me, { inPlatformView, inSupportView })
}
